/**
 * ⛔ BẢN SAO CÓ CHỦ Ý, VÀ ĐÂY LÀ LÝ DO — `web/` không nhập được từ `server/` (hai gói, hai
 *   `tsconfig`, hai lần dựng). Nên luật "ai đã làm việc này" tồn tại hai bản.
 *
 * ⚠ HAI BẢN CỦA MỘT LUẬT LÀ HAI BẢN SẼ TRÔI KHỎI NHAU (L67). Chốt giữ chúng không trôi nằm ở
 *   bộ kiểm `[71]`: nó ĐỐI CHIẾU từng câu chữ và tiền tố của tệp này với
 *   `server/src/services/nguonthaotac.ts`. Sửa một bên mà quên bên kia ⇒ ĐỎ.
 *
 * 🔴 Vì sao phải phân biệt ba câu — xem khối đầu tệp bên máy chủ. Tóm tắt: `userId = null`
 *   hôm nay bị vẽ thành "hệ thống", mà "người bấm màn hình tủ" KHÔNG phải "hệ thống".
 */
export const TIEN_TO_TAI_TU = 'TAI_TU_';

export function laThaoTacTaiTu(action: string): boolean {
  return action.startsWith(TIEN_TO_TAI_TU);
}

/** `null` = hàng CÓ tài khoản ⇒ chỗ vẽ hiện tên người. */
export function aiDaLam(action: string, coTaiKhoan: boolean): string | null {
  if (coTaiKhoan) return null;
  return laThaoTacTaiTu(action)
    ? 'tại tủ — không qua tài khoản'
    : 'hệ thống (tự động)';
}
